import type { IconData } from '@stacksjs/iconify-core'

export const contentClip: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M5.75 0A3.75 3.75 0 0 1 9.5 3.75l.004 6.75H6.5V4H5v8h6.004V4H14v6a6 6 0 0 1-12 0V3.75A3.75 3.75 0 0 1 5.75 0\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default contentClip
